module.exports = __webpack_public_path__ + "static/media/icons8-folder.483e9684.svg";